module.exports = __webpack_public_path__ + "static/media/butter-map-branding.17c6a19a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/butter-map-branding.png
// module id = 16
// module chunks = 0